export interface WorkflowLogger {
  info(event: string, context: Record<string, unknown>): void;
  warn(event: string, context: Record<string, unknown>): void;
  error(event: string, context: Record<string, unknown>): void;
}

/** Console-based logger that emits structured JSON lines. */
export function createWorkflowLogger(
  base: Record<string, unknown> = {},
): WorkflowLogger {
  const emit = (
    level: string,
    event: string,
    context: Record<string, unknown>,
  ) => {
    const entry = { level, event, ...base, ...context, ts: Date.now() };
    if (level === "error") {
      console.error(JSON.stringify(entry));
    } else if (level === "warn") {
      console.warn(JSON.stringify(entry));
    } else {
      console.info(JSON.stringify(entry));
    }
  };

  return {
    info: (event, ctx) => emit("info", event, ctx),
    warn: (event, ctx) => emit("warn", event, ctx),
    error: (event, ctx) => emit("error", event, ctx),
  };
}
